/*
 * @Description  : 自定义插件
 * @usage        :
 * @Date         : 2021-09-27 19:48:47
 * @Author       : hadeshe<hadeshe@tencent.com>
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-21 21:00:14
 * @FilePath: /vise/packages/app-share/src/plugins/custom.ts
 */
import type { App } from 'vue';
import EventEmitter from 'events';
import { MAX_LISTENERS_CNT } from '@/constants/index';

export default {
  install: (vueApp: App) => {
    const app = vueApp;

    // 安装事件总线
    const evtBus = new EventEmitter();
    evtBus.setMaxListeners(MAX_LISTENERS_CNT);
    app.config.globalProperties.$evtBus = evtBus;
  },
};
